<template>
  <sidebar-section
    class="cart-modal"
    is-modal
    :is-opened="isCartOpen"
    @close-sidebar="setIsCartOpen(false)"
  >
    <template v-slot:close-button>
      <close-button class="sidebar-close-button" @click="setIsCartOpen(false)" />
    </template>
    <cart-standalone v-if="isCartOpen" />
  </sidebar-section>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import SidebarSection from '@/components/common/SidebarSection.vue';
import CloseButton from '@/components/common/CloseButton.vue';

import { ICON } from '@/constants/icons';
import { types } from '@/store/types';

export default {
  name: 'CartModal',
  components: {
    SidebarSection,
    CloseButton,
    CartStandalone: () => import(/* webpackPrefetch: true */ '@/components/cart/CartStandalone.vue')
  },
  closeButtonName: ICON.CLOSE,
  computed: {
    ...mapState({
      isCartOpen: types.state.IS_CART_OPEN
    })
  },
  methods: {
    ...mapMutations({
      setIsCartOpen: types.mutations.SET_IS_CART_OPEN
    })
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/sidebar-section.scss';
</style>
